/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refresh_ButtonInputs */

const en_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const id_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbarui`)
};

const ms_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segar semula`)
};

const ca_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualitza`)
};

const cs_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit`)
};

const da_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdater`)
};

const de_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu laden`)
};

const et_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Värskenda`)
};

const es_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const fr_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser`)
};

const hr_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osvježi`)
};

const it_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const lv_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atsvaidzināt`)
};

const lt_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnaujinti`)
};

const hu_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frissítés`)
};

const nl_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vernieuw`)
};

const nb_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last inn på nytt`)
};

const pl_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odśwież`)
};

const pt_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

const ro_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizează`)
};

const sk_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnoviť`)
};

const sl_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osveži`)
};

const fi_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä`)
};

const sv_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdatera`)
};

const vi_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm mới`)
};

const tr_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenile`)
};

const el_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανανέωση`)
};

const bg_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опресняване`)
};

const ru_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить`)
};

const sr_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Освежи`)
};

const uk_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оновити`)
};

const ka_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`განახლება`)
};

const hi_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रीफ्रेश करें`)
};

const th_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเฟรช`)
};

const ko_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로 고침`)
};

const zh_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新`)
};

const zh_tw_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新整理`)
};

const ja_refresh_button = /** @type {(inputs: Refresh_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Refresh_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const refresh_button = /** @type {((inputs?: Refresh_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refresh_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_refresh_button(inputs)
	if (locale === "ms") return ms_refresh_button(inputs)
	if (locale === "ca") return ca_refresh_button(inputs)
	if (locale === "cs") return cs_refresh_button(inputs)
	if (locale === "da") return da_refresh_button(inputs)
	if (locale === "de") return de_refresh_button(inputs)
	if (locale === "et") return et_refresh_button(inputs)
	if (locale === "es") return es_refresh_button(inputs)
	if (locale === "fr") return fr_refresh_button(inputs)
	if (locale === "hr") return hr_refresh_button(inputs)
	if (locale === "it") return it_refresh_button(inputs)
	if (locale === "lv") return lv_refresh_button(inputs)
	if (locale === "lt") return lt_refresh_button(inputs)
	if (locale === "hu") return hu_refresh_button(inputs)
	if (locale === "nl") return nl_refresh_button(inputs)
	if (locale === "nb") return nb_refresh_button(inputs)
	if (locale === "pl") return pl_refresh_button(inputs)
	if (locale === "pt") return pt_refresh_button(inputs)
	if (locale === "ro") return ro_refresh_button(inputs)
	if (locale === "sk") return sk_refresh_button(inputs)
	if (locale === "sl") return sl_refresh_button(inputs)
	if (locale === "fi") return fi_refresh_button(inputs)
	if (locale === "sv") return sv_refresh_button(inputs)
	if (locale === "vi") return vi_refresh_button(inputs)
	if (locale === "tr") return tr_refresh_button(inputs)
	if (locale === "el") return el_refresh_button(inputs)
	if (locale === "bg") return bg_refresh_button(inputs)
	if (locale === "ru") return ru_refresh_button(inputs)
	if (locale === "sr") return sr_refresh_button(inputs)
	if (locale === "uk") return uk_refresh_button(inputs)
	if (locale === "ka") return ka_refresh_button(inputs)
	if (locale === "hi") return hi_refresh_button(inputs)
	if (locale === "th") return th_refresh_button(inputs)
	if (locale === "ko") return ko_refresh_button(inputs)
	if (locale === "zh") return zh_refresh_button(inputs)
	if (locale === "zh-tw") return zh_tw_refresh_button(inputs)
	if (locale === "ja") return ja_refresh_button(inputs)
	return en_refresh_button(inputs)
});